// Firebase configuration
// Get your config from Firebase Console: https://console.firebase.google.com/
import { initializeApp } from "firebase/app";
import { connectAuthEmulator, getAuth } from "firebase/auth";

// VITE_USE_FIREBASE_EMULATOR is exported by dev.sh in local development.
// When set, we point the Firebase JS SDK at the local Auth emulator instead
// of the real Firebase project. The apiKey / authDomain values become
// placeholders that the SDK still demands but the emulator ignores.
const useEmulator =
  import.meta.env.DEV && import.meta.env.VITE_USE_FIREBASE_EMULATOR === "true";

const firebaseConfig = useEmulator
  ? {
      apiKey: "fake-api-key",
      authDomain: "localhost",
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "demo-bt-scheduler",
    }
  : {
      apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
      authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN,
      projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID,
      storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET,
      messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID,
      appId: import.meta.env.VITE_FIREBASE_APP_ID,
    };

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);

if (useEmulator) {
  connectAuthEmulator(auth, "http://localhost:9099", { disableWarnings: true });
}
